import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AddGame from './pages/AddGame';
import ClaimGame from './pages/ClaimGame';
import Leaderboards from './pages/Ranking';
import LaunchingSoon from './pages/LaunchingSoon';
import TokenPage from './pages/TokenPage';
import HowItWorks from './pages/HowItWorks';
import NotFound from './pages/NotFound';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Ticker from './components/Ticker';

import { MarketProvider, FeaturedMarketProvider } from './contexts/MarketContext';
import { AuthProvider } from './contexts/AuthContext';
import './styles/styles.css';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <FeaturedMarketProvider>
        <MarketProvider>
          <div className="App">
            <Ticker />
            <Header />
            <main className="container">
              <Routes>
                <Route path="/" element={<Home/>} />
                <Route path="/add" element={<AddGame/>} />
                <Route path="/claim" element={<ClaimGame/>} />
                <Route path="/launching" element={<LaunchingSoon/>} />
                <Route path="/leaderboards" element={<Leaderboards />} />
                <Route path="/token/:id" element={<TokenPage />} />
                <Route path="/how-it-works" element={<HowItWorks/>} />
                <Route path="/signin" element={<SignIn/>} />
                <Route path="/signup" element={<SignUp/>} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </MarketProvider>
        </FeaturedMarketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;